import noop from "lodash/noop";
import { createContext } from "react";
const NeuralInterfaceContext = createContext({
    activeInput: "Input",
    recognizeText: undefined,
    toggleInputMode: noop,
    startVoiceRecording: noop,
    stopVoiceRecording: noop,
    checkVoiceRecord: noop,
    voiceRecorderRef: { current: null },
    addOnGraph: noop,
    saveFIle: noop,
    addFile: noop,
    addVoiceRecord: noop,
    addText: noop
});
export default NeuralInterfaceContext;
